export default "__VITE_ASSET__1ecfe83d__"